import { UseQueryResult, useQuery, QueryClient } from '@tanstack/react-query';
import { SIMULATION_ENDPOINT_PREFIX } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { SimulationNonRecurrentEnvelopeData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';
import { HR_SIMULATION_NON_RECURRENT_ENVELOPE_DATA_API_KEY } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/hooks/agentsSimulation';
import { RQAPICallWithData } from 'store/APIClient';
import { Response } from 'routes/HumanResourcesModule/business/types';
import {
    invalidateEnvelopeQueries,
    resetEnvelopeQueries,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/helpers/apiHelpers';

export const resetSimulationEnvelopeDataQueries = (
    hrSimulationId: number,
    queryClient: QueryClient,
) => {
    resetEnvelopeQueries(queryClient);
    queryClient.resetQueries({
        queryKey: [
            HR_SIMULATION_NON_RECURRENT_ENVELOPE_DATA_API_KEY,
            hrSimulationId,
        ],
    });
};

export const invalidateSimulationEnvelopeDataQueries = (
    hrSimulationId: number,
    queryClient: QueryClient,
) => {
    invalidateEnvelopeQueries(queryClient);
    queryClient.invalidateQueries({
        queryKey: [
            HR_SIMULATION_NON_RECURRENT_ENVELOPE_DATA_API_KEY,
            hrSimulationId,
        ],
    });
};

export const useGetHrSimulationNonRecurrentEnvelopeData = (
    hrSimulationId: number,
): UseQueryResult<Response<SimulationNonRecurrentEnvelopeData>> =>
    useQuery({
        queryKey: [
            HR_SIMULATION_NON_RECURRENT_ENVELOPE_DATA_API_KEY,
            hrSimulationId,
        ],
        queryFn: async () => {
            const response = await RQAPICallWithData<
                Response<SimulationNonRecurrentEnvelopeData>
            >({
                endpoint: `${SIMULATION_ENDPOINT_PREFIX}/${hrSimulationId}/non_recurrent_envelope_simulation_data`,
            });
            return response.content.data;
        },
    });
